module.exports = __webpack_public_path__ + "static/img/win_prize.e5369d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/826/win_prize.png
// module id = 504
// module chunks = 1